import Net from '../../util/net';
import { AuthorizeReq, AuthorizeRsp, GetBotDetailReq, GetBotDetailRsp } from '../../typings/proto';

export default {
  /** 获取bot消息 */
  getBotDetail(botId: string, gid: string, needPerms = true): Promise<GetBotDetailRsp> {
    return new Promise((resolve, reject) => {
      Net.request<GetBotDetailRsp, GetBotDetailReq>({
        path: 'knockknock.BotStoreSrv/GetBotDetail',
        data: { botId, gid, needPerms },
      }).then((result) => {
        resolve(result);
      })
        .catch(reject);
    });
  },
  /** bot鉴权参数获取 */
  authorize({
    appid,
    redirectUri,
    responseType,
    scope,
    state,
  }: AuthorizeReq = {
    appid: '',
    redirectUri: '',
    responseType: 'code',
    scope: 'openapi_userinfo',
    state: '',
  }): Promise<AuthorizeRsp> {
    return new Promise((resolve, reject) => {
      Net.request<AuthorizeRsp, AuthorizeReq>({
        path: 'knockknock.BotOAuthSrv/Authorize',
        data: {
          appid, redirectUri, responseType, scope, state },
      }).then((result) => {
        resolve(result);
      })
        .catch(reject);
    });
  },
};
